import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Grid } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUrl } from "src/Utils/Common";
import PromotionSkusTable from "src/Components/Tables/Promotion/PromotionSKUsTable";
import PromotionTable from "src/Components/Tables/Promotion/PromotionTable";
import PromotionTable2 from "src/Components/Tables/Promotion/PromotionTable2";

function Promotion() {

const projectId = useSelector((state) => state.userProject.projectId);
const[hierarchy, setHierarchy] = useState("brand");
const [manufacturer, setManufacturer] = useState("SAVOLA GROUP")
const [manufacturers, setManufacturers] = useState([])
const [promoTypes] = useState(["PX", "CP"])
const [promoType, setPromoType] = useState("PX")
const [selectedHier, setSelectedHier]= useState("");
const [selectedBrand, setSelectedBrand] = useState("");
const [selectedClass, setSelectedClass] = useState("");

const handleHierSelect = (event) =>{
    setHierarchy(event.target.value)
  }

const handleManuSelect = (event) =>{
    setManufacturer(event.target.value)
  }

const handlePromoType = (event) =>{
  setPromoType(event.target.value)
}

const handleSelection = (brand, classValue = null) => {
  setSelectedBrand(brand || "");
  setSelectedClass(classValue || "");
  setSelectedHier(brand || classValue || ""); 
}

useEffect(() => {
  function fetchManufacturers() {
    if (!projectId) {
      console.warn("[Promo] Project ID is not set in Redux state.");
      return;
    }

    fetch(`${getUrl()}/market_overview/hierarchy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("userId") || "",
        "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
      },
      body: JSON.stringify({ project_id: projectId }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((result) => {
        const manufacturersList = result["0"]?.manufacturer || [];
        setManufacturers(manufacturersList);
      })
      .catch((error) => {
        console.error("[Promo] Error fetching manufacturers:", error);
      });
  }

  fetchManufacturers();
}, [projectId]);

useEffect(()=>{
  console.log(selectedHier)
},[selectedHier])

useEffect(()=>{
  setSelectedHier("")
  setSelectedBrand("")
  setSelectedClass("")
},[hierarchy])

useEffect(()=>{
  setSelectedHier("")
  setSelectedBrand("")
  setSelectedClass("")
},[manufacturer])
const manufacturersOptions = projectId === 5 || projectId === 6
  ? manufacturers.filter(
      (item) => item === "SAVOLA GROUP" || item === "IFFCO GROUP"
    )
  : manufacturers;

useEffect(() => {
  if (!manufacturersOptions.length) {
    return;
  }

  if (!manufacturer || !manufacturersOptions.includes(manufacturer)) {
    const fallback =
      (projectId === 5 || projectId === 6) &&
      manufacturersOptions.includes("SAVOLA GROUP")
        ? "SAVOLA GROUP"
        : manufacturersOptions[0];

    setManufacturer(fallback);
  }
}, [manufacturersOptions, manufacturer, projectId]);

return (
    <Box>
      <Grid item xs={12} md={12}>
        <PromotionTable2 manufacturer={manufacturer}/>
      </Grid>
      
            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', margin: '15px' }}>
                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #ccc' }} />

                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">Manufacturer</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={manufacturer}
                    label="Manufacturer"
                    onChange={handleManuSelect}
                  >
                    {manufacturersOptions.map((item, id) =>{
                      return(
                        <MenuItem key={id} value={item}>{item}</MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">Hierarchy</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={hierarchy}
                    label="Hierarchy"
                    onChange={handleHierSelect}
                  >
                    <MenuItem value={"brand"}>Brand</MenuItem>
                    <MenuItem value={"Class"}>class</MenuItem>
                  </Select>
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">Promo Types</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={promoType}
                    label="Promo Types"
                    onChange={handlePromoType}
                  >
                    {promoTypes.map((item, id) =>{
                      return(
                        <MenuItem key={id} value={item}>{item}</MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #ccc' }} />
            </div>
            <Grid item xs={12} md={12}>
              <PromotionTable hierarchy={hierarchy} manufacturer={manufacturer} promoType={promoType} setSelectedHier={handleSelection}/>
          </Grid>
          {selectedHier===""?
          
          <></>
        
          :
          <Grid item xs={12} md={12}>
              <PromotionSkusTable manufacturer={manufacturer} promoType={promoType} selectedBrand={selectedBrand} selectedClass={selectedClass}/>
          </Grid>
          }
            
            
      </Box>
)
}

export default Promotion;